import { z } from "zod";

// Contracts for the internal project-transfer routes
// (/api/internal/projects/transfer/{export,import}). Both routes are
// gated by requireInternalAdmin — they exist for staff tooling (the
// `ripenn internal project download/upload` CLI commands), not for
// product surface.

export const TransferExportRequest = z.object({
  projectId: z.string().uuid(),
});
export type TransferExportRequest = z.infer<typeof TransferExportRequest>;

export const TransferExportResponse = z.object({
  /** Base64-encoded JSON ExportBlob (tables + embedded HTML blobs). */
  blob: z.string(),
  exportedAt: z.string().datetime(),
});
export type TransferExportResponse = z.infer<typeof TransferExportResponse>;

export const TransferImportRequest = z.object({
  /** Base64-encoded JSON ExportBlob, as returned by the export route. */
  blob: z.string(),
  targetOrgId: z.string().uuid(),
});
export type TransferImportRequest = z.infer<typeof TransferImportRequest>;

export const TransferImportResponse = z.object({
  projectId: z.string().uuid(),
});
export type TransferImportResponse = z.infer<typeof TransferImportResponse>;
